import React from 'react';
import { motion } from 'framer-motion';

const companies = [
  {
    name: 'Company 1',
    logo: '/company1.png',
  },
  {
    name: 'Company 2',
    logo: '/company2.png',
  },
  {
    name: 'Company 3',
    logo: '/company3.png',
  },
  {
    name: 'Company 4',
    logo: '/company1.png',
  },
  {
    name: 'Company 5',
    logo: '/company2.png',
  },
];

export const TrustedCompanies = (): JSX.Element => {
  return (
    <motion.section
      className="flex flex-col items-center gap-4 md:gap-6 lg:gap-8 py-4 md:py-6 relative w-full max-w-candidate-ui mx-auto"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}>
      <div className="w-full h-px bg-gray-200" />

      <div className="inline-flex flex-col items-center px-4 md:px-5 py-0">
        <p className="m-0 flex items-center justify-center w-fit font-['Inter'] font-medium text-[18px] leading-[27px] text-center text-[var(--midnight-900)]">
          Trusted by 3000+ businesses across the world
        </p>
      </div>

      <div className="relative w-full h-8 md:h-10 lg:h-12 overflow-hidden">
        <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

        <div className="flex animate-scroll-horizontal">
          <div className="flex items-center gap-8 md:gap-12 lg:gap-16 min-w-max px-4">
            {companies.map((company, index) => (
              <img
                key={`${company.name}-${index}`}
                className="h-12 w-auto object-contain opacity-60 hover:opacity-100 transition-opacity"
                alt={company.name}
                src={company.logo}
              />
            ))}
            {companies.map((company, index) => (
              <img
                key={`duplicate-${index}`}
                className="h-12 w-auto object-contain opacity-60 hover:opacity-100 transition-opacity"
                alt={company.name}
                src={company.logo}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="w-full h-px bg-gray-200" />
    </motion.section>
  );
};
